const servicesData = [
  { name: 'Bathrooms', path: 'bathrooms', image: '/Assets/bathrooms.jpeg', description: 'Transform your bathroom into a modern and luxurious space.' },
  { name: 'Flooring', path: 'flooring', image: '/Assets/flooring.png', description: 'High-quality flooring install.' },
  { name: 'Kitchens', path: 'kitchens', image: '/Assets/kitchens.png', description: 'Custom kitchen remodeling to match your style.' },
  { name: 'Carpentry, Doors, Trim and Paint', path: 'trim', image: '/Assets/trim.png', description: 'Expert trim work, Door install and Paint.' },
];

export default servicesData;